<template>
  <div class="order-container">
    <div class="order-content">
      <!--售后、工单步骤-->
      <service-process
        :processType="processType"
        :processInfo="processInfo"
        :ticketCount="ticketCount"
      >
        <order-info :orderInfo="orderInfo"/>
      </service-process>
      <!--推荐问题-->
      <div>
        <link-cell
          v-for="(qs, idx) in recommendedContent"
          :zz-sortid="idx" :zz-sortname="qs"
          :key="qs"
          :legoId="qs"
          :text="qs"
          :skillId="skillId"
          :athenaChannel="athenaChannel"
          :fromPage="recommandOrders"
          :curBizCate="curBizCate"
        />
      </div>
    </div>
  </div>
</template>

<script>
import OrderInfo from './components/OrderInfo'
import ServiceProcess from './components/ServiceProcess'
import LinkCell from '../LinkCell'

export default {
  name: 'recommandOrder',
  props: {
    recommandOrderInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    skillId: {
      type: String
    },
    athenaChannel: {
      type: String
    },
    curBizCate: {
      type: Object
    }
  },
  computed: {
    orderInfo() { // 订单信息
      return this.recommandOrderInfo.orderInfo || {}
    },
    recommendedContent() { // 推荐内容
      const { recommendedContent: { option = [] } = {} } = this.recommandOrderInfo
      return option.slice(0, 6)
    },
    assInfo() { // 售后信息
      return this.recommandOrderInfo.assDto
    },
    ticketInfo() { // 工单信息
      return this.recommandOrderInfo.ticketDto
    },
    ticketCount() {
      const count = this.recommandOrderInfo.assAndTicketCount
      return count ? Number(count) : 0
    },
    processType() { // 为0是单独订单
      let type = 0
      if (this.assInfo) {
        type = 2
      } else if (this.ticketInfo) {
        type = 1
      }
      return type
    },
    processInfo() {
      return this.assInfo || this.ticketInfo || {}
    }
  },
  components: {
    OrderInfo,
    ServiceProcess,
    LinkCell
  },
  data() {
    return {
      recommandOrders: 'RECOMMANDORDER'
    }
  }
}

</script>
<style lang="less" scoped>
  @import 'index.less';
</style>